
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ListMixin from "@/mixins/Crud/ListMixin";
import DefaultTableLayout from "@/layout/DefaultTableLayout.vue";
import AppConfig from "@/config/AppConfig";

const UserModule = namespace(AppConfig.USER_STORE);

@Component({
  components: { DefaultTableLayout },
  mixins: [ListMixin],
})
export default class UserList extends Vue {
  protected name = "UserList.vue";

  @Prop({ required: false, default: "Dashboard" })
  public redirectRouteNameOnDeleteSuccess!: string;

  @Prop({ required: false, default: "name" })
  public descriptionField!: string;

  @UserModule.Getter("getDataList")
  protected list: any;

  @UserModule.Action("findAll")
  protected loadList: any;

  @UserModule.Getter("getIsLoading")
  protected isLoading: any;

  protected get resource(): string {
    return "/user";
  }

  protected init() {}
}
